<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">404</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="/notfound">404</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="notfound ptb--60">
  <div class="container">
    <div class="row justify-content-center align-items-center text-center">
      <div class="col-12 col-lg-6">
        <div class="notfound-404">
          <h2>404</h2>
        </div>
        <h3 class="mt-2 fw-bold">Page Not Found</h3>
        <p class="text-center">We're sorry, the page you requested could not be found.<br>Please go back to the
          homepage.</p>
        <a routerLink="/" class="cmn-button mt-3">Back to Home Page</a>
      </div>
    </div>
  </div>
</section>
